import { cn } from "@/lib/utils";
import { MarketplaceListingCardSkeleton } from "./MarketplaceListingCardSkeleton";
import { MarketplaceListingListCardSkeleton } from "./MarketplaceListingListCardSkeleton";

interface ListingGridSkeletonProps {
  count?: number;
  className?: string;
}

export function ListingGridSkeleton({
  count = 8,
  className,
}: ListingGridSkeletonProps) {
  return (
    <>
      <div
        className={cn(
          "border-gray-200 -mx-4 flex w-[calc(100%+2rem)] flex-col rounded-none border-x-0 border-t-0 bg-white sm:-mx-6 sm:w-[calc(100%+3rem)] md:hidden",
          className
        )}>
        {Array.from({ length: count }).map((_, index) => (
          <MarketplaceListingListCardSkeleton key={index} isGrouped />
        ))}
      </div>

      <div
        className={cn(
          "hidden gap-4 md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
          className
        )}>
        {Array.from({ length: count }).map((_, index) => (
          <MarketplaceListingCardSkeleton key={index} />
        ))}
      </div>
    </>
  );
}
